

export default [
	{
		path: '',
		name: 'User',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserHome')
	},
	{
		path: 'bets',
		name: 'UserBets',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserBets'),
		children: [
			{
				path: ':betId',
				name: 'UserBetsWithId',
				component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserBets'),
			}
		]
	},
	{
		path: 'transactions',
		name: 'UserTransactions',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserTransactions')
	},
	{
		path: 'payin',
		name: 'UserPayin',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserPayinPage'),
		children: [
			{
				path: '',
				name: 'UserPayin',
				component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserPayin')
			},
			{
				path: ':status',
				name: 'UserPayinResponse',
				component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserPayinResponse')
			}
		]
	},
	{
		path: 'payout',
		name: 'UserPayout',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserPayout')
	},
	{
		path: 'data',
		name: 'UserData',
		component: () => import(/* webpackChunkName: "authorization-required" */ '@/components/user/UserData/index')
	},
]